import inflight from 'promise-inflight';
import {getSegmentTrackAdditionalProps} from '../util';
let isReady = false;
const blackListedCategory = ['PAGE'];

function loadSegment(API_KEY) {
	return new Promise(function (resolve, reject) {
		if(!API_KEY){
			reject(new TypeError('No SEGMENT_WRITE_KEY'));
		}
		if(isReady){
			resolve();
		}

		!function(){
			const cdnHost = 'seg.patsnap.io'
			function getJsSrc(key) {
				// return "cdn.segment.com/analytics.js/v1/"+key+"/analytics.min.js"
				return `${cdnHost}/patsnap/${key}/a.js`
			}
			var analytics=window.analytics=window.analytics||[];
			analytics._cdn = `https://${cdnHost}`
			if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement("script");e.type="text/javascript";e.async=!0;e.src=("https:"===document.location.protocol?"https://":"http://")+getJsSrc(t);var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION="4.0.0";


			analytics.load(API_KEY, { integrations: { "Segment.io": { apiHost: `${cdnHost}/v1` }}})
			return analytics
		}}();

		let calledId = setTimeout(resolve, 2000);

		analytics.ready(function () {
			clearTimeout(calledId);
			resolve();
		});
	});
}


export default function loadSegmentSDK(API_KEY) {
	return inflight(`segload_${API_KEY}`, () => {
		return loadSegment(API_KEY).then(() => isReady = true);
	})
}

export function formatTrackDataToSegmentSDKArguments(trackData) {
	let attr = trackData.attr || {};
	delete trackData.attr;
	let d = Object.assign({},trackData,attr);
	if(d.segment === false){
		return undefined
	}else if(blackListedCategory.indexOf(d.category) >= 0){
		return undefined
	}else{
		delete d.action_type;
		delete d.action_time;
		delete d.segment;

		let trackArgs = [
			d.action,
			Object.assign(getSegmentTrackAdditionalProps(), d)
		];

		if (d.action === 'SmartImageRollTimes') {
			// trackArgs[2] = {
			//   integrations: {
			// 	'All': true,
			//   }
			// }
		} else {
			trackArgs[2] = {
			  integrations: {
				  // Destination Names
				  'SmartImageRollTimes': false,
				  'SmartImageRollTimes [CN]': false,
				  'SmartImageRollTimes [EU]': false,
				  'SmartImageRollTimes [US]': false,
				  'SmartImageRollTimes Release': false,
			  }
			}
		}

		return trackArgs;
	}
}
